import { AppProviders } from './providers';
import { AppRouter } from './router';
import { ErrorBoundary } from '@/components/feedback/ErrorBoundary';

/** App.tsx - deliberately tiny: providers wrap the router, an ErrorBoundary wraps everything. All real setup lives in providers.tsx/router.tsx, not here. */
export function App() {
  return (
    <ErrorBoundary>
      <AppProviders>
        <AppRouter />
      </AppProviders>
    </ErrorBoundary>
  );
}
